export enum PowerUnit {
  KWH = 'kWh',
  MWH = 'MWh',
  GWH = 'GWh',
}

export interface PowerConsumption {
  usage: number;
  unit: string;
}
